import { create } from 'zustand';

interface ComposerState {
  open: boolean;
  draftId: string | null;
  inReplyToMessageId: string | null;
  forwardOfMessageId: string | null;
  threadId: string | null;
  initialTo: { name?: string; address: string }[];
  initialSubject: string;
  initialBody: string;

  openCompose: (opts?: {
    draftId?: string;
    inReplyToMessageId?: string;
    forwardOfMessageId?: string;
    threadId?: string;
    to?: { name?: string; address: string }[];
    subject?: string;
    body?: string;
  }) => void;
  close: () => void;
}

export const useComposer = create<ComposerState>((set) => ({
  open: false,
  draftId: null,
  inReplyToMessageId: null,
  forwardOfMessageId: null,
  threadId: null,
  initialTo: [],
  initialSubject: '',
  initialBody: '',
  openCompose: (opts = {}) =>
    set({
      open: true,
      draftId: opts.draftId ?? null,
      inReplyToMessageId: opts.inReplyToMessageId ?? null,
      forwardOfMessageId: opts.forwardOfMessageId ?? null,
      threadId: opts.threadId ?? null,
      initialTo: opts.to ?? [],
      initialSubject: opts.subject ?? '',
      initialBody: opts.body ?? '',
    }),
  close: () =>
    set({
      open: false,
      draftId: null,
      inReplyToMessageId: null,
      forwardOfMessageId: null,
      threadId: null,
      initialTo: [],
      initialSubject: '',
      initialBody: '',
    }),
}));
